/* eslint-disable global-require */
let devState;
try {
  devState = require('./dev_state');
} catch (ex) {
  // console.log('There is no dev state: ' + ex);
}

const state = {
  authToken: undefined,
  registrationStatus: undefined,
  userOverwriteBrowserLanguage: false,
};

if (devState && process.env.NODE_ENV === 'development') {
  Object.assign(state, devState.default);
}
export default state;
